import React, { useEffect, useState } from 'react'
import react from './compo images/react.png'
import mern from './compo images/mern.jpg'
import workdata from './Works_data'
import Aos from 'aos';
import "aos/dist/aos.css"
//importing redux
import { createStore } from 'redux';
import allReducers from './projects/projcompo/TodoAppRedux/Reducers'//here it automatically calls index file in reducers folder
import { Provider } from 'react-redux';
//here called devtool
//mini projects components
import CryptoApiApp from './projects/projcompo/Apiapp/CryptoApiApp'
import Cart from './projects/projcompo/CartSystem/Cart'
import Quizroutepage from './projects/projcompo/QuizApp/Quizroutepage'
import TdApp from './projects/projcompo/TodoAppRedux/TdApp';
//importing DescAlert
import DescAlert from './DescAlert';
const reduxStore = createStore(allReducers, window.__REDUX_DEVTOOLS_EXTENSION__ && window.__REDUX_DEVTOOLS_EXTENSION__());//creating store



const projdivcss = {
    width: "100%",
    height: "fit-content",
    margin: "0px auto",
    background: "white",
    marginBottom: "20px"
}

function Works() {
    //use history to from one page to another
    const [Currproj, Upcurproj] = useState("");
    const [alert, upalert] = useState("no");
    //function for closing alert
    const closeButton = () => {
        upalert("no");
    }
    const state = (id) => {
        Upcurproj(JSON.stringify(id));
        upalert("yes");
    }
    //for showing number of projects 
    const reactProj = workdata.filter(data => data.type === "react");
    const mernproject = workdata.filter(data => data.type === "mern");
    // useEffect(() => {
    //     Aos.init({ duration: 1000 });
    // }, [])
    if (Currproj === "")
        return (
            <>
                <div className="row mt-5">
                    <div className="col text-center">
                        <p className="h2">Projects</p>
                        <p className="text-primary">Self made projects</p>
                    </div>
                </div>
                <div className="row">
                    <div className="col">
                        <h3 className="ml-5 p-2 head" style={{ color: "purple" }}>React mini projects = (<img id="reactico" src={react} style={{ width: "40px" }} alt="react image" />) = <i class="fa fa-angle-right" id="reactarrow" aria-hidden="true"></i></h3>
                    </div>
                </div>
                <div className="row">
                    <div className="col-12">
                        <div className="corosel">
                            <div id="carouselExampleIndicators1" className="carousel slide" data-ride="carousel">
                                <ol className="carousel-indicators">
                                    <li key={workdata[0].id} className="pagindicator" data-target="#carouselExampleIndicators1" data-slide-to={workdata[0].id}></li>
                                    {
                                        reactProj.map((data) => {
                                            if (data.id !== 0)
                                                return (
                                                    <>
                                                        <li className="pagindicator" key={data.id} data-target="#carouselExampleIndicators" data-slide-to={data.id}></li>
                                                    </>
                                                )
                                        })
                                    }
                                </ol>
                                <div className="carousel-inner">
                                    <div className="carousel-item active">
                                    {/*i created this extra carousel item to use active class */}
                                        <img className="d-block w-100" src={workdata[0].imgsrc} alt="First slide" />
                                        <div class="carousel-caption text-dark">
                                            <h5 className="tit" style={{ background: "purple", padding: "5px 10px", borderRadius: "5px", color: "white", width: "fit-content", margin: "10px auto" }}>{workdata[0].title} </h5>
                                            <a href={workdata[0].github} target="_blank" className="btn btn-danger btn-sm mb-3" >Source Code</a>
                                            <a href="#" className="btn btn-success btn-sm ml-2 mb-3" onClick={() => state(workdata[0].id)}>Show Live</a>
                                        </div>
                                    </div>
                                    {
                                        reactProj.map((data) => {
                                            if (data.id !== 0)
                                                return (
                                                    <>
                                                        <div className="carousel-item">
                                                            <img className="d-block w-100" src={data.imgsrc} alt="Second slide" />
                                                            <div class="carousel-caption text-dark">
                                                                <h5 className="tit" style={{ background: "purple", padding: "5px 10px", borderRadius: "5px", color: "white", width: "fit-content", margin: "10px auto" }}>{data.title} </h5>
                                                                <a href={data.github} target="_blank" className="btn btn-danger btn-sm mb-3" >Source Code</a>
                                                                <a href="#" className="btn btn-success btn-sm ml-2 mb-3" onClick={() => state(data.id)}>Show Live</a>
                                                            </div>
                                                        </div>
                                                    </>
                                                )
                                        })
                                    }

                                </div>
                                <a className="carousel-control-prev" href="#carouselExampleIndicators1" role="button" data-slide="prev">
                                    <span className="text-dark" style={{ fontSize: "30px" }} aria-hidden="true"><i className="fa fa-angle-left" style={{ fontSize: "36px" }}></i></span>
                                    <span className="sr-only">Previous</span>
                                </a>
                                <a className="carousel-control-next" href="#carouselExampleIndicators1" role="button" data-slide="next">
                                    <span className="text-dark" style={{ fontSize: "30px" }} aria-hidden="true"><i className="fa fa-angle-right" style={{ fontSize: "36px" }}></i></span>
                                    <span className="sr-only">Next</span>
                                </a>
                            </div>
                        </div>
                    </div>
                </div>
                <div className="row mt-5" >
                    <div className="col">
                        <h3 className="ml-5 p-2 head" style={{ color: "purple" }}>Major projects using MERN <i class="fa fa-angle-right" id="reactarrow" aria-hidden="true"></i></h3>
                    </div>
                </div>
                <div className="row mb-5" >
                    <div className="col-12">
                        <div className="corosel">
                            <div id="carouselExampleIndicators2" className="carousel slide" data-ride="carousel">
                                <ol className="carousel-indicators">
                                    <li key={workdata[4].id} className="pagindicator" data-target="#carouselExampleIndicators2" data-slide-to={workdata[0].id}></li>
                                    {
                                        mernproject.map((data) => {
                                            if (data.id !== 4)
                                                return (
                                                    <>
                                                        <li className="pagindicator" key={data.id} data-target="#carouselExampleIndicators2" data-slide-to={data.id}></li>
                                                    </>
                                                )
                                        })
                                    }
                                </ol>
                                <div className="carousel-inner">
                                    <div className="carousel-item active">
                                    {/*i created this extra carousel item to use active class */}
                                        <img className="d-block w-100" src={workdata[4].imgsrc} alt="First slide" />
                                        <div class="carousel-caption text-dark">
                                            <h5 className="tit" style={{ background: "purple", padding: "5px 10px", borderRadius: "5px", color: "white", width: "fit-content", margin: "10px auto" }}>{workdata[4].title} </h5>
                                            <a href={workdata[4].github}  className="btn btn-danger btn-sm mb-3" >Source Code</a>
                                            <a href="#" onClick={() => state(workdata[4].id)} className="btn btn-success btn-sm ml-2 mb-3">Show Live</a>
                                        </div>
                                    </div>
                                    {
                                        mernproject.map((data) => {
                                            if (data.id !== 4)
                                                return (
                                                    <>
                                                        <div className="carousel-item">
                                                            <img className="d-block w-100" src={data.imgsrc} alt="Second slide" />
                                                            <div class="carousel-caption text-dark">
                                                                <h5 className="tit" style={{ background: "purple", padding: "5px 10px", borderRadius: "5px", color: "white", width: "fit-content", margin: "10px auto" }}>{data.title} </h5>
                                                                <a href="#" className="btn btn-danger btn-sm mb-3" >Source Code</a>
                                                                <a href="#" onClick={() => state(data.id)} className="btn btn-success btn-sm ml-2 mb-3">Show Live</a>
                                                            </div>
                                                        </div>
                                                    </>
                                                )
                                        })
                                    }

                                </div>
                                <a className="carousel-control-prev" href="#carouselExampleIndicators2" role="button" data-slide="prev">
                                    <span className="text-dark" style={{ fontSize: "30px" }} aria-hidden="true"><i className="fa fa-angle-left" style={{ fontSize: "36px" }}></i></span>
                                    <span className="sr-only">Previous</span>
                                </a>
                                <a className="carousel-control-next" href="#carouselExampleIndicators2" role="button" data-slide="next">
                                    <span className="text-dark" style={{ fontSize: "30px" }} aria-hidden="true"><i className="fa fa-angle-right" style={{ fontSize: "36px" }}></i></span>
                                    <span className="sr-only">Next</span>
                                </a>
                            </div>
                        </div>
                    </div>
                </div>
            </>

        )
    if (Currproj === "0")
        return (
            <>
                {alert === "yes" ? (<>
                    <DescAlert
                        title={workdata[Currproj].title}
                        tecUsed={workdata[Currproj].techUsed}
                        conUsed={workdata[Currproj].conceptUsed}
                        desc={workdata[Currproj].desc}
                        closeButton={closeButton}
                        type={workdata[Currproj].type}
                    />
                </>) :
                    <div className="row">
                        <div className="col">
                            <button onClick={() => Upcurproj("")} className="btn btn-danger m-3 p-2 btn-sm"><img src="https://cdn-icons-png.flaticon.com/512/709/709624.png" width="16px" alt="" /> Back</button>
                            <div style={projdivcss}>
                                <CryptoApiApp />
                            </div>
                        </div>
                    </div>
                }
            </>
        )
    if (Currproj === "1")
        return (
            <>
                {alert === "yes" ? (<>
                    <DescAlert
                        title={workdata[Currproj].title}
                        tecUsed={workdata[Currproj].techUsed}
                        conUsed={workdata[Currproj].conceptUsed}
                        desc={workdata[Currproj].desc}
                        closeButton={closeButton}
                        type={workdata[Currproj].type}
                    />
                </>) :
                    <div className="row">
                        <div className="col">
                            <button onClick={() => Upcurproj("")} className="btn btn-danger m-3 p-2 btn-sm"><img src="https://cdn-icons-png.flaticon.com/512/709/709624.png" width="16px" alt="" /> Back</button>
                            <div style={projdivcss}>
                                <Cart />
                            </div>
                        </div>
                    </div>
                }
            </>
        )
    if (Currproj === "2")
        return (
            <>
                {alert === "yes" ? (<>
                    <DescAlert
                        title={workdata[Currproj].title}
                        tecUsed={workdata[Currproj].techUsed}
                        conUsed={workdata[Currproj].conceptUsed}
                        desc={workdata[Currproj].desc}
                        closeButton={closeButton}
                        type={workdata[Currproj].type}
                    />
                </>) :
                    <div className="row">
                        <div className="col">
                            <button onClick={() => Upcurproj("")} className="btn btn-danger m-3 p-2 btn-sm"><img src="https://cdn-icons-png.flaticon.com/512/709/709624.png" width="16px" alt="" /> Back</button>
                            <div style={projdivcss}>
                                <Quizroutepage />
                            </div>
                        </div>
                    </div>
                }
            </>
        )
    if (Currproj === "3")
        return (
            <>
                {alert === "yes" ? (<>
                    <DescAlert
                        title={workdata[Currproj].title}
                        tecUsed={workdata[Currproj].techUsed}
                        conUsed={workdata[Currproj].conceptUsed}
                        desc={workdata[Currproj].desc}
                        closeButton={closeButton}
                        type={workdata[Currproj].type}
                    />
                </>) :
                    <div className="row">
                        <div className="col">
                            <button onClick={() => Upcurproj("")} className="btn btn-danger m-3 p-2 btn-sm"><img src="https://cdn-icons-png.flaticon.com/512/709/709624.png" width="16px" alt="" /> Back</button>
                            <div style={projdivcss}>
                                <Provider store={reduxStore}>
                                    <TdApp />
                                </Provider>,
                            </div>
                        </div>
                    </div>
                }
            </>
        )
    if (Currproj === "4")
        return (
            <>
                {alert === "yes" ? (<>
                    <DescAlert
                        title={workdata[Currproj].title}
                        tecUsed={workdata[Currproj].techUsed}
                        desc={workdata[Currproj].desc}
                        closeButton={closeButton}
                        type={workdata[Currproj].type}
                    />
                </>) :
                    (window.location.replace(workdata[Currproj].source))
                }
            </>
        )
}

export default Works
